export default "/36022bc732d21dcfe768d2a0d43278c292b1a1e5/ed3e1222f5d7e466f1889a4510f1de5c.svg";